import React from 'react';
import ChannelBadge from './ChannelBadge';
import { CHANNEL } from '../../utils/bookingSource';

/** @deprecated Use ChannelBadge — kept for existing imports. */
const PrivateBookingBadge = ({ className = '', showIcon = true }) => (
  <ChannelBadge channel={CHANNEL.EXTERNAL} className={className} showIcon={showIcon} />
);

export default PrivateBookingBadge;
